const cn = (...classes: (string | boolean | undefined | null | false)[]): string =>
  classes.filter(Boolean).join(' ')

export default cn
